const localStorageKeys = {
  USER_INFO: "user_info",
  TOKEN: "token"
};

export default localStorageKeys;
